import { Outlet } from "react-router";
import { Alert403 } from "@/shared/components/alerts/alert-403";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { BaseDataPage } from "../_components/layout/base-data-page";

export function BusinessCentralRoute() {
  const canAccess = useFeatureAuth("businesscentral.matches");
  if (!canAccess) {
    return (
      <BaseDataPage>
        <Alert403 />
      </BaseDataPage>
    );
  }

  return <Outlet />;
}
